import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 0.5rem;
`;

const TextBold = styled.p`
  font-weight: 600;
  margin: 0;
`;

const TooltipContent = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 12px;
  background-color: #fff;
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  font-size: var(--font-size-xs);
  line-height: 1.4;
  white-space: pre-line;
  max-width: 500px;
  width: 100%;
  min-width: 150px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease, visibility 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: var(--color-primary);
  }

  @media (max-width: 768px) {
    max-width: 500px;
    font-size: 12px;
    padding: 10px;
  }
`;

function Tooltip({ children }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      <TooltipContent visible={isVisible}>
        <p><TextBold>Need it faster? </TextBold>Select this option to expedite your appraisal. Rush is subject to Appraiser availability and lender approval.
          Please allow 24 hours for Confirmation   Additional $150 rush fee applies.
        </p>
      </TooltipContent>
    </TooltipContainer>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Tooltip;
